<template>
  <footer class="app-footer">
    <div class="copyright">
      © BEW Berliner Energie und Wärme GmbH {{ new Date().getFullYear() }}
    </div>
    <div class="other-links">
      <a href="https://www.bew.berlin/datenschutz/">{{
        $t('footer.privacy')
      }}</a>
      <a
        href="https://www.bew.berlin/impressum-bew-berliner-energie-und-waerme-gmbh/"
        >{{ $t('footer.legalNotice') }}</a
      >
    </div>
  </footer>
</template>

<script src="./AppFooter.script.ts" lang="ts"></script>
<style src="./AppFooter.styles.scss" lang="scss" scoped></style>
